// extracted by mini-css-extract-plugin
export default {"wrapper":"bo-z","response":"co-z","error":"do-z","disabled":"eo-z","buttons":"fo-z","feedbackQuestionSection":"go-z","yesNoWrapper":"ho-z"};